<template>
<div class="lvIconBageBox" @click="sendFlower">
<!--  图片-->
  <div class="img" >
    <img :src="src" alt="dd">
    <div class="badgeNum">{{ num }}</div>
  </div>
<!--  名字-->
  <div class="name">{{ name }}</div>
<!--  描述-->
  <div class="describe" v-if="describe!=''">{{ describe }}</div>
</div>
</template>

<script>
export default {
  name: "lvIconBadge",
  props:{
    src:{
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    describe: {
      type: String,
      required: true
    },
    num: {
      type: Number,
      required: true
    },
  },
  methods:{
    sendFlower(){
      console.log("sendFlower")
      this.$emit("sendFlower")
    }
  }
}
</script>

<style scoped>
.lvIconBageBox{
  width: 180px;
}
.img{
  position: relative;
  width: 140px;
  height: 140px;
  margin-left: 20px;
  /*background-color: #ff5777;*/
}
.badgeNum{
  position: absolute;
  top: -20px;
  left: 95px;
  background-color: #ee0a24;
  font-size: 38px;
  color: whitesmoke;

  border-radius: 38px;
  padding-left: 8px;
  padding-right: 8px;
}
.name{
  color: #06050b;
  font-size: 38px;
  text-align: center;
}
.describe{
  color: #666666;
  font-size: 34px;
  text-align: center;

}
</style>